import styled from "styled-components";
import {rem} from "@/styles/theme";


export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
  padding: ${rem(30)} ${rem(18)};
  background-color: ${({theme}) => theme.color['gray-100']};

`

export const LogoWrapper = styled.div`
  position: relative;
  width: 100px;
  aspect-ratio: 104 / 19.25;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};

  .company {
    display: flex;
    gap: ${rem(8)};
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.01em;
    color: #212121;
  }

  .address {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: -0.01em;
    color: #757575;
  }

  .cs {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: -0.01em;
    color: #757575;

    a {
      color: #757575;
      text-decoration: underline;
    }
  }

  .copy-right {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: -0.01em;
    color: #757575;
  }
`

export const AppWrapper = styled.div`
  position: relative;
  display: flex;
  gap: ${rem(8)};
`

export const Image = styled.img`
`

